module.exports = __webpack_public_path__ + "static/media/USSF-90-Min-Display-Bold.51c071bb.woff";